// src/lib/intake/intakeFlag.js
//
// Ticket 061 (Advisor Intake I4). The browser switch for the /intake route.
// Same convention as the server switch (supabase/functions/_shared/intake/
// intakeFlag.ts): only the exact string "true" turns it on. It is read at BUILD
// time (Create React App inlines REACT_APP_* values), so changing it needs a
// new build.

export function isIntakeRouteEnabled(value) {
  return value === 'true'
}
